import React from "react";
import styled from "styled-components";
import { DropdownButton, MenuItem, DeleteMenuItem } from "components/bootstrap";
import { ConfigurationForm, ConfigurationWell } from "components/configurationforms";
import InlineForm from "./InlineForm";
import DecoratorStyles from "./decoratorStyles.css";
const SpacedActions = styled.div`
  margin-left: 5px;
`;
class DecoratorSummary extends React.Component {
  constructor(props) {
    super(props);
    this._handleDeleteClick = () => {
      const { onDelete, decorator } = this.props;
      if (window.confirm("Do you really want to delete this decorator?")) {
        onDelete(decorator.id);
      }
    };
    this._handleEditClick = () => {
      this.setState({ editing: true });
    };
    this._closeEditForm = () => {
      this.setState({ editing: false });
    };
    this._handleSubmit = (data) => {
      const { decorator } = this.props;
      const { stream, id, order } = decorator;
      const { onUpdate } = this.props;
      onUpdate(id, {
        id,
        type: data.type,
        config: data.configuration,
        order,
        stream
      });
      this._closeEditForm();
    };
    // Attempts to resolve ID values in the decorator configuration against the type definition.
    // This allows users to see actual names for entities in drop-downs, instead of their IDs.
    this._resolveConfigurationIds = (config) => {
      const { typeDefinition } = this.props;
      const typeConfig = typeDefinition.requested_configuration;
      const resolvedConfig = {};
      const configKeys = Object.keys(config);
      configKeys.forEach((key) => {
        const configValues = typeConfig[key] ? typeConfig[key].additional_info.values : void 0;
        const originalValue = config[key];
        if (configValues) {
          if (configValues[originalValue]) {
            resolvedConfig[key] = configValues[originalValue];
          }
        }
      });
      return { ...config, ...resolvedConfig };
    };
    this._formatActionsMenu = () => {
      const { decorator } = this.props;
      return /* @__PURE__ */ React.createElement(SpacedActions, null, /* @__PURE__ */ React.createElement(DropdownButton, { id: `decorator-${decorator.id}-actions`, bsStyle: "default", bsSize: "xsmall", title: "Actions" }, /* @__PURE__ */ React.createElement(MenuItem, { onSelect: this._handleEditClick }, "Edit"), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: this._handleDeleteClick }, "Delete")));
    };
    this.state = {
      editing: false
    };
  }
  render() {
    const { disableMenu = false, decorator, decoratorTypes, typeDefinition } = this.props;
    const { editing } = this.state;
    const config = this._resolveConfigurationIds(decorator.config);
    const decoratorType = decoratorTypes[decorator.type] || { name: "Unknown decorator type" };
    const decoratorActionsMenu = disableMenu || this._formatActionsMenu();
    const { name, requested_configuration: requestedConfiguration } = typeDefinition;
    const wrapperComponent = InlineForm("Update");
    const decoratorId = decorator.id || "new";
    const content = editing ? /* @__PURE__ */ React.createElement(
      ConfigurationForm,
      {
        key: "configuration-form-decorator",
        configFields: requestedConfiguration,
        title: `Edit ${name}`,
        typeName: decorator.type,
        includeTitleField: false,
        submitAction: this._handleSubmit,
        cancelAction: this._closeEditForm,
        wrapperComponent,
        values: decorator.config
      }
    ) : /* @__PURE__ */ React.createElement(
      ConfigurationWell,
      {
        key: `configuration-well-decorator-${decoratorId}`,
        id: decoratorId,
        configuration: config,
        typeDefinition
      }
    );
    return /* @__PURE__ */ React.createElement("span", { className: DecoratorStyles.fixedWidth }, /* @__PURE__ */ React.createElement("div", { className: DecoratorStyles.decoratorBox }, /* @__PURE__ */ React.createElement("h6", null, decoratorType.name), decoratorActionsMenu), content);
  }
}
DecoratorSummary.defaultProps = {
  disableMenu: false
};
export default DecoratorSummary;
